/**
 * Default wording for the message keys the field schemas emit, as the content of
 * a `fieldSchema` namespace.
 *
 * The schemas set translation keys rather than sentences, so a product that uses
 * them owes its locale an entry for each. Shipping the wording beside the schemas
 * makes that debt payable by spreading one object instead of remembering which
 * keys exist; a product that wants different words overrides the entry it cares
 * about. A test asserts this table and the keys the schemas emit match exactly,
 * so neither side can drift from the other unnoticed.
 */
export const fieldSchemaMessages = {
    date: {
        invalid: "Invalid date",
        invalidInFuture: "Date cannot be in the future",
    },
    dateTime: {
        invalid: "Invalid date and time",
        invalidInFuture: "Date and time cannot be in the future",
    },
    time: {
        invalid: "Invalid time",
    },
};
//# sourceMappingURL=fieldSchemaMessages.js.map